import { colors } from '../../colors';
var para = {
  messageColor: colors.brickOrange
};
export default para;